import { render, staticRenderFns } from "./privacyAgreement.vue?vue&type=template&id=7633f69c&scoped=true&"
import script from "./privacyAgreement.vue?vue&type=script&lang=js&"
export * from "./privacyAgreement.vue?vue&type=script&lang=js&"
import style0 from "./privacyAgreement.vue?vue&type=style&index=0&id=7633f69c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7633f69c",
  null
  
)

export default component.exports